"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Toggle = void 0;
const react_1 = __importDefault(require("react"));
const Toggle_styled_1 = require("./Toggle.styled");
const Toggle = ({ firstValue, secondValue, selectedValue, unit, onSelect, small, disabled, dataTestId, }) => {
    const isChecked = selectedValue === secondValue;
    return (react_1.default.createElement(Toggle_styled_1.ToggleWrapperStyled, { small: small, disabled: disabled, "data-test": "toggle", "data-test-id": dataTestId },
        react_1.default.createElement(Toggle_styled_1.TextValuesStyled, null, [firstValue, secondValue].map((value, index) => (react_1.default.createElement(Toggle_styled_1.ValueWrapperStyled, { selected: value === selectedValue, "data-test": "toggle-value", "data-test-id": `toggle-value-${value === selectedValue ? 'selected' : 'unselected'}`, key: index },
            react_1.default.createElement(Toggle_styled_1.ValueStyled, null,
                " ",
                value,
                " "),
            react_1.default.createElement(Toggle_styled_1.UnitStyled, { className: "ml-2" }, unit))))),
        react_1.default.createElement(Toggle_styled_1.ToggleInputStyled, { onChange: (event) => !disabled && onSelect(event.target.checked ? secondValue : firstValue), checked: isChecked }),
        react_1.default.createElement(Toggle_styled_1.ToggleStyled, null)));
};
exports.Toggle = Toggle;
